import React from 'react'
import '../css/PostProperty.css';
import check from "../images/check1.jpg";

const PopUp = () => {
    return (
        <div>
            <div className='popupbox'>
                <div className="popup">
                    <div className='check-div'>
                        <img src={check} alt="Popup" className="check" />
                    </div>
                    <div className='mb-5'>
                        <h2 className='congr-text'>Congratulations! Your property is under review.</h2>
                        <p className='congr-text-p'>Meanwhile you can add photos/Videos & other additional details of your property to receive more enquiries</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PopUp
